import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-388fe8a4")

_pushScopeId("data-v-388fe8a4")
const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = { class: "slices" }
const _hoisted_3 = { class: "flex-center margin-bottom-10" }
const _hoisted_4 = { class: "flex-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重新合成")
const _hoisted_6 = {
  key: 0,
  class: "font-32 el-icon-loading"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("重新上传")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("发布")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_demo_slices = _resolveComponent("demo-slices")
  const _component_publish_dialog = _resolveComponent("publish-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_page_header, {
        onBack: _ctx.goBack,
        content: "音频结构"
      }, null, 8, ["onBack"]),
      _createVNode(_component_el_divider),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_demo_slices, { slices: _ctx.slices }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("audio", {
                controls: "",
                src: _ctx.demoUrl
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_4, [
              (_ctx.demo.templateId)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _ctx.reMerge
                  }, {
                    default: _withId(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (!_ctx.demo.templateId)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 1,
                    action: _ctx.fileUploadPath,
                    headers: _ctx.tokenHeader,
                    "on-success": _ctx.handleUploaded,
                    "on-error": _ctx.handleUploadError,
                    "before-upload": _ctx.beforeUpload,
                    "show-file-list": false,
                    accept: "image/*"
                  }, {
                    default: _withId(() => [
                      (_ctx.showUploading)
                        ? (_openBlock(), _createBlock("i", _hoisted_6))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_button, {
                        class: "margin-right-10",
                        type: "primary"
                      }, {
                        default: _withId(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["action", "headers", "on-success", "on-error", "before-upload"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "success",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.publishDialogVisible=true))
              }, {
                default: _withId(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["slices"])
      ])
    ]),
    _createVNode(_component_publish_dialog, {
      modelValue: _ctx.publishDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.publishDialogVisible = $event)),
      onConfirm: _ctx.publish
    }, null, 8, ["modelValue", "onConfirm"])
  ], 64))
})